import styled, { css } from "styled-components";

export type DividerOrientation = "vertical" | "horizontal";

export const LineStyle = styled.hr<{
  orientation: DividerOrientation;
  thickness?: number;
  length?: number;
}>`
  background: ${({ theme }) => theme.color.stroke.light};
  border: none;
  margin: 0;

  ${({ orientation, thickness = 1, length, theme }) =>
    orientation === "horizontal"
      ? css`
          width: ${length ? `${length / theme.remToPx}rem` : "100%"};
          height: ${thickness / 10}rem;
        `
      : css`
          width: ${thickness / 10}rem;
          height: ${length ? `${length / theme.remToPx}rem` : "100%"};
        `}
`;
